import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/NumericalSeries/NumericalSeriesForm.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NumericalSeriesForm } from '../../../forms/NumericalSeries/NumericalSeriesForm';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { paths } from '../../RouterContainer';
import { useTranslation } from '../../../context/translationContext';
import { COMPANY_TABS } from '../Company/UserCompaniesUpdatePage';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useEffect } from 'react';
import { useLoading } from '../../../context/loadingContext';

/**
 * Component to create numerical series for current company
 */
export const NumericalSeriesCreatePage = () => {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const { t } = useTranslation();
  const { company } = useCurrentCompany();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  const isCurrent = window.location.pathname.includes(`current`);
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
          paths.NUMERICAL_SERIES
        }/create`,
        name: 'navigation.numerical-series-create',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`, {
      state: { tab: COMPANY_TABS.NUMERICAL_SERIES },
    });

  /**
   * Handles create action for new bank account form submit.
   * Uses company create API.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    if (!company) return;
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.NUMERICAL_SERIES_CREATE,
        data: { ...values, companyId: company.id },
      });
      if (response?.status === 201) {
        stopLoading();
        toast.success('Success!');
        navigate(
          `/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
            paths.NUMERICAL_SERIES
          }/edit/${response.data?.id}`,
        );
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.numerical-serie.headline-create')}</h1>
      <NumericalSeriesForm onSubmit={handleSubmit} onBack={handleOnBack} />
    </div>
  );
};
